import React, { useState, useEffect } from "react";
import { AppStrings } from "../../../utils";
import { Document, Page, pdfjs } from "react-pdf";
import { useAppSelector } from "../../../../../app/hooks";
import Modal from "../../../../../components/ui/Modal";

interface Props {
  open: boolean;
  onNo: () => void;
}

export const PreviewDocsModal: React.FC<Props> = ({ open, onNo }) => {
  
  const { documents } = useAppSelector((state) => state.remittance);
  
  const [pageNumber, setPageNumber] = useState(4);
  const [type, setType] = useState("pdf");

  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    setType("pdf");
  }, [open]);

  const onDocumentLoadSuccess = ({ numPages }: any) => {
    setPageNumber(numPages);
    setType("pdf");
  };

  const onDocumentLoadError = ({ name }: any) => {
    if (name == "InvalidPDFException") {
      setType("image");
    }
  };
  return (
    <Modal
      modalClass="!rounded overflow-y-scroll max-h-[90%] lg:max-h-[90%] !w-full lg:!w-2/3 !p-0"
      header={AppStrings.PREVIEW_DOCS.DOCUMENTS_PREVIEW}
      headerClass="mt-2 px-4 lg:!px-12 py-4 lg:!py-7"
      visible={open}
      closeHandler={onNo}
    >
      <div>

        {documents?.previewDocs?.loading && (
          <div className="p-4 flex justify-center items-center">
            <div className="animate-spin h-6 w-6 border-2 border-t-blue-500 rounded-full" />
          </div>
        )}

        {!documents?.previewDocs?.loading && (
        <div className="flex items-center justify-center object-contain py-24 bg-white-100">
          <div className="w-1/2">
            {type == "pdf" ? (
              <Document
                file={documents?.previewDocs?.fileURL}
                onLoadError={onDocumentLoadError}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                {Array.from(new Array(pageNumber), (el, index) => (
                  <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
              </Document>
            ) : (
              <img src={documents?.previewDocs?.fileURL} alt="uploadedDoc" />
            )}
          </div>
        </div>
        )}

      </div>
    </Modal>
  );
};
